module.exports = __webpack_public_path__ + "img/he_05.220c1b19.png";